<template>
  <div 
    class="p-coverImage" 
    :class="{
      'is-fixed': isFixed,
      'is-scaled': isScaled,
    }" 
    :style="{
      width: `${width}px`,
      height: `${height}px`,
      top: `${top}px`,
      left: `${left}px`,
    }">
    <div class="p-coverImage__image" ref="image" :style="{
      'background-image': `url(${src})`
    }"></div>

    <div class="p-coverImage__name">
      <span 
        v-for="(letter, i) in dest_name" 
        :style="{
          'transition-delay': `${i / 10}s`
        }"
        @transitionend="onTransitionendLetter(i)">{{ letter }}</span>
    </div>
    <!-- <img :src="src" alt="" class="u-cover"> -->
  </div>
</template>


<script>
  /**
   * Modules
   */
  import { mapGetters, mapMutations } from 'vuex'
  import { TweenMax } from 'gsap'

  const DURATION = 0.8

  /**
   * Share Partial
   */

  export default {
    name: 'cover-image',
    data() {
      return {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
      }
    },
    computed: {
      isMobile() {
        return this.$window.viewport === 'mobile'
      },
      ...mapGetters({
        'src': 'coverImage/src',
        'dest_name': 'coverImage/dest_name',
        'size': 'coverImage/size',
        'position': 'coverImage/position',
        'isFixed': 'coverImage/isFixed',
        'isScaled': 'coverImage/isScaled',
      }),
    },
    watch: {
      isFixed(value) {
        if(value) {
          this.scale()
        } else {
          this.setCoverImageScaleState(false)
        }
      },
      // isScaled(value) {
      //   if(!value) {
      //     this.shrink()
      //   }
      // }
    },
    mounted() {
    },
    methods: {
      scale() {
        // 拡大
        this.setProps()
        

        this.$el.style.willChange = 'width, height, top, left'
        this.$refs.image.style.willChange = 'transform'

        this.$nextTick(() => {
          this.$refs.image.style.transform = 'scale(1.2)'

          TweenMax.to(this.$el, DURATION, {
            ease: Power3.easeInOut,
            // width: this.isMobile ? global.innerWidth : global.innerWidth - this.left,
            width: global.innerWidth,
            height: global.innerHeight,
            top: 0,
            // left: this.isMobile ? 0 : this.left,
            left: 0,
            onComplete: () => {
              this.setCoverImageScaleState(true)
            }
          })  
        })

        
      },
      shrink() {
        // 縮小
        this.$nextTick(() => {
          

          this.$refs.image.style.transform = 'scale(1)'

          TweenMax.to(this.$el, DURATION, {
            ease: Power3.easeInOut,
            width: this.size.width,
            height: this.size.height,
            top: this.position.top,
            left: this.position.left,
            onComplete: () => {
              this.setId('')
              this.setSrc('')
              this.setSize({
                width: 0,
                height: 0
              })
              this.setPosition({
                top: 0,
                left: 0
              })

              this.setProps()

              this.$el.style.willChange = 'auto'
              this.$refs.image.style.willChange = 'auto'
            }
          })  
        })
      },
      setProps() {
        this.width = this.size.width
        this.height = this.size.height
        this.top = this.position.top
        this.left = this.position.left
      },
      onTransitionendLetter(index) {
        if(!this.isScaled && index === this.dest_name.length - 1) {
          this.shrink()
        }
      },
      ...mapMutations({
        'setId': 'coverImage/SET_ID',
        'setSrc': 'coverImage/SET_SRC',
        'setSize': 'coverImage/SET_SIZE',
        'setPosition': 'coverImage/SET_POSITION',
        'setCoverImageScaleState': 'coverImage/SET_SCALE_STATE'
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/partial/cover-image.vue